/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Dropdown, Checkbox } from 'yankees-react-utils';

const getDropdownFilterValue = (pitchFilter) => (typeof pitchFilter === 'object' ? pitchFilter.value : pitchFilter);

const PitchExecutionFilters = ({ onFilterChange, pitches, isCatcher, value }) => {
    const { t: translate } = useTranslation();
    const innings = Array.from(new Set(pitches.map((p) => p.inning)));
    const batters = pitches.reduce((acc, p) => { if (!acc[p.batterid]) acc[p.batterid] = p; return acc; }, {}) || {};
    const pitchers = pitches.reduce((acc, p) => { if (!acc[p.pitcherid]) acc[p.pitcherid] = p; return acc; }, {});

    const inningOpts = [null, ...innings].map((i) => ({ name: i || translate('common.all'), value: i }));
    const batterOpts = [null, ...Object.values(batters)]
        .sort((a, b) => a?.eventseq - b?.eventseq)
        .map((b) => ({ name: b ? `${b.batterusesname} ${b.batterlastname}` : translate('common.all'), value: b ? b.batterid : b }));
    const pitcherOpts = Object.values(pitchers)
        .sort((a, b) => a?.eventseq - b?.eventseq)
        .map((p) => ({ name: `${p.pitcherusesname} ${p.pitcherlastname}`, value: p.pitcherid }));

    const [inningFilter, setInningFilter] = useState(inningOpts[1]);
    const [pitcherFilter, setPitcherFilter] = useState(pitcherOpts[0]);
    const [batterFilter, setBatterFilter] = useState(batterOpts[0]);
    const [flaggedPitchFilter, setFlaggedPitchFilter] = useState(false);

    useEffect(() => {
        onFilterChange({
            inning: getDropdownFilterValue(inningFilter),
            pitcherid: getDropdownFilterValue(pitcherFilter),
            batterid: getDropdownFilterValue(batterFilter),
            review: !!flaggedPitchFilter,
        });
    }, [onFilterChange, inningFilter, pitcherFilter, batterFilter, flaggedPitchFilter]);
    useEffect(() => {
        if (value) {
            if (value.inning && value.inning !== getDropdownFilterValue(inningFilter)) setInningFilter(value.inning);
        }
    }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
    return (
        <div>
            <div>
                <label>{translate('baseball.inning')}:</label>
                <Dropdown options={inningOpts} value={inningFilter} onSelect={setInningFilter} />
                <label>{translate('baseball.batter')}:</label>
                <Dropdown options={batterOpts} value={batterFilter} onSelect={setBatterFilter} />
                {(isCatcher == true || isCatcher > 0) && (
                    <>
                        <label>{translate('baseball.pitcher_one')}:</label>
                        <Dropdown options={pitcherOpts} value={pitcherFilter} onSelect={setPitcherFilter} />
                    </>
                )}
            </div>
            <div>
                <Checkbox id="flagged" label={translate('sections.post-game.pitch-execution.show-flagged-pitches')} onChange={(e) => setFlaggedPitchFilter(e.currentTarget.checked)} />
            </div>
        </div>
    );
};

PitchExecutionFilters.propTypes = {
    onFilterChange: PropTypes.func.isRequired,
    pitches: PropTypes.arrayOf(PropTypes.shape({
        inning: PropTypes.number.isRequired,
        batterid: PropTypes.number.isRequired,
        pitcherid: PropTypes.number.isRequired,
    })).isRequired,
    isCatcher: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    value: PropTypes.shape({
        inning: PropTypes.number,
        pitcherid: PropTypes.number,
        batterid: PropTypes.number,
        review: PropTypes.bool,
    }),
};
PitchExecutionFilters.defaultProps = {
    isCatcher: false,
    value: undefined,
};

export default PitchExecutionFilters;
